import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import styled from 'styled-components';
import { supabase } from '../../lib/supabaseClient';
import * as api from '../../api';
import Spinner from '../Atoms/Spinner';
import toast, { Toaster } from 'react-hot-toast';
import ExcelJS from 'exceljs';
import JSZip from 'jszip';
import GetProjectMainImage from '../Utils/GetProjectMainImage';
import ThreeModelViewer from '../Components/ThreeModelViewer';
import AF_MEMBER_NAMES from './Admin/afMembers';
import BIBLE_FABRICANTS from './Admin/bibleFabricants';

// ─── Winner project IDs (same as FD100Exposition) ───
const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc', '67a0b8331b103d938bafa954', '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c', '67e6c18043d5609350e381a8', '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73', '67bf2330b1ba28c3144af8d2', '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63', '67c6b416db48cb16a13c73c7', '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c', '67d15108d95ccf24eaf191df', '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e', '662adc507159e5b1b1da7c75', '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2', '682b5c5f754f51df2ef93bbc', '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb', '67daebf343d5609350e27a9e', '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360', '67e1452a43d5609350e2b066', '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97', '67e3e1cb43d5609350e304e5', '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a', '67e42d7043d5609350e32539', '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0', '67e529f743d5609350e33a8c', '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f', '67e5764d43d5609350e34cb5', '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3', '67e58da443d5609350e3561d', '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905', '67e6828d43d5609350e36b6a', '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667', '67e6c0a843d5609350e380cf', '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900', '67e7003c43d5609350e38bfc', '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae', '67f90250a0262e085d37088f', '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e', '67ab6ade07736060460b3c16', '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d', '6800b8529167c049fff50e47', '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f', '6800fad59167c049fff52224', '680113739167c049fff52d73',
    '680106139167c049fff525af', '680125219167c049fff53405', '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e', '68020ef79167c049fff54015', '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7', '680249249167c049fff55a19', '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037', '680270379167c049fff566f5', '680274c09167c049fff567c8',
    '680275419167c049fff567de', '68027b389167c049fff56954', '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f', '6849787b17dde4ca4c4bf043', '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4', '6808c3f59167c049fff599c7', '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee', '6801e2f49167c049fff53ce1', '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49', '6810df4a264e7745556ad75d', '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977', '680fa9f09167c049fff5e027', '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62', '6818cac19e656d77bc6c72fa', '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0', '682d97b2754f51df2ef96070', '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a'
];

const EVENT_ID = '67590da5499bcc995c210b40';

const DESIGNER_NAME_OVERRIDES = {
    '67d8718c43d5609350e25c38': 'Maentler Studio',
};

// ─── Styled Components ──────────────────────────────────
const PageWrapper = styled.div`
    min-height: 100vh;
    background: #f8f9fa;
`;

const TopBar = styled.div`
    background: white;
    padding: 16px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid #e0e0e0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    position: sticky;
    top: 0;
    z-index: 100;
`;

const LogoArea = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    h1 {
        font-size: 20px;
        color: #333;
        margin: 0;
        font-weight: 700;
    }
    .subtitle {
        font-size: 13px;
        color: #888;
        margin-top: 2px;
    }
`;

const Container = styled.div`
    max-width: 1800px;
    margin: 0 auto;
    padding: 30px 20px;
`;

const StatsSection = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 16px;
    margin-bottom: 30px;
`;

const StatCard = styled.div`
    background: ${props => props.color || 'white'};
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    .value { font-size: 32px; font-weight: 700; color: ${props => props.textColor || '#333'}; }
    .label { font-size: 13px; color: ${props => props.textColor ? `${props.textColor}aa` : '#666'}; margin-top: 6px; }
`;

const TableSection = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
    padding: 30px;
    overflow-x: auto;
`;

const TableHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 12px;
    h2 { font-size: 20px; color: #333; margin: 0; }
`;

const HeaderActions = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
`;

const SearchInput = styled.input`
    padding: 10px 16px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    width: 280px;
    transition: border-color 0.2s;
    &:focus { outline: none; border-color: #e67e22; }
`;

const ActionButton = styled.button`
    padding: 10px 20px;
    background: ${props => {
        if (props.variant === 'primary') return 'linear-gradient(135deg, #e67e22, #d35400)';
        if (props.variant === 'success') return 'linear-gradient(135deg, #27ae60, #229954)';
        return 'linear-gradient(135deg, #ecf0f1, #bdc3c7)';
    }};
    color: ${props => props.variant ? 'white' : '#333'};
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
    &:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    th {
        text-align: left;
        padding: 14px 12px;
        background: #f8f9fa;
        font-weight: 600;
        font-size: 13px;
        color: #555;
        border-bottom: 2px solid #e0e0e0;
        white-space: nowrap;
    }
    td {
        padding: 12px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 14px;
        vertical-align: middle;
    }
    tr:hover td { background: #fafafa; }
`;

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    background: ${props => {
        if (props.type === 'oui') return '#d4edda';
        if (props.type === 'non') return '#f8d7da';
        if (props.type === 'pending') return '#fff3cd';
        if (props.type === 'contact') return '#d1ecf1';
        if (props.type === 'objet') return '#e8f4f8';
        if (props.type === 'espace') return '#fef3e2';
        return '#e9ecef';
    }};
    color: ${props => {
        if (props.type === 'oui') return '#155724';
        if (props.type === 'non') return '#721c24';
        if (props.type === 'pending') return '#856404';
        if (props.type === 'contact') return '#0c5460';
        if (props.type === 'objet') return '#1a5276';
        if (props.type === 'espace') return '#e67e22';
        return '#495057';
    }};
`;

const PhotoThumb = styled.img`
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 6px;
    cursor: pointer;
    transition: transform 0.2s;
    &:hover { transform: scale(1.1); }
`;

const NoPhoto = styled.div`
    width: 60px;
    height: 60px;
    border-radius: 6px;
    background: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ccc;
    font-size: 20px;
`;

const ToggleButton = styled.button`
    padding: 6px 14px;
    border: 2px solid ${props => props.active ? '#27ae60' : props.refused ? '#e74c3c' : '#95a5a6'};
    background: ${props => props.active ? '#d4edda' : props.refused ? '#f8d7da' : '#ecf0f1'};
    color: ${props => props.active ? '#155724' : props.refused ? '#721c24' : '#7f8c8d'};
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    &:hover { transform: scale(1.05); }
`;

const EmptyState = styled.div`
    text-align: center;
    padding: 60px 20px;
    color: #999;
    font-size: 16px;
`;

const PieceRow = styled.tr`
    td {
        background: ${props => props.pending ? '#fffde7 !important' : 'inherit'};
    }
    &:hover td {
        background: ${props => props.pending ? '#fff9c4 !important' : '#fafafa'};
    }
`;

const LightboxOverlay = styled.div`
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.85);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img { max-width: 90vw; max-height: 90vh; object-fit: contain; border-radius: 8px; }
`;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.5);
    z-index: 9000;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ModalContent = styled.div`
    background: white;
    border-radius: 16px;
    padding: 32px;
    width: 800px;
    max-width: 95vw;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 20px 60px rgba(0,0,0,0.3);
    h2 { font-size: 22px; margin: 0 0 24px 0; color: #333; }
`;

const FormGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
`;

const FormField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    ${props => props.full && 'grid-column: 1 / -1;'}
    label { font-size: 13px; font-weight: 600; color: #555; }
`;

const ModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #eee;
`;

const ModelViewerWrapper = styled.div`
    width: 80px;
    height: 80px;
    border-radius: 8px;
    overflow: hidden;
    background: #f5f5f5;
    cursor: pointer;
    border: 1px solid #e0e0e0;
    transition: box-shadow 0.2s;
    &:hover { box-shadow: 0 2px 12px rgba(0,0,0,0.15); }
    model-viewer {
        width: 100%;
        height: 100%;
        --poster-color: transparent;
    }
`;

const ModelViewerLargeWrapper = styled.div`
    width: 100%;
    height: 500px;
    border-radius: 12px;
    overflow: hidden;
    background: #f0f0f0;
    model-viewer {
        width: 100%;
        height: 100%;
    }
`;

const No3D = styled.div`
    width: 80px;
    height: 80px;
    border-radius: 8px;
    background: #f8f8f8;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ddd;
    font-size: 13px;
`;

// ─── Load model-viewer web component ────────────────────
const loadModelViewer = () => {
    if (document.querySelector('script[src*="model-viewer"]')) return;
    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
    document.head.appendChild(script);
};

// ─── Helpers ────────────────────────────────────────────
const isGlbOrGltf = (url) => {
    const lower = (url || '').toLowerCase();
    return lower.includes('.glb') || lower.includes('.gltf');
};

const get3dFileForPiece = (dispoRow) => {
    if (!dispoRow?.file_3d_urls?.length) return null;
    const urls = dispoRow.file_3d_urls.filter(u => u);
    if (!urls.length) return null;
    // Prefer glb/gltf (viewable in model-viewer), fallback to any 3D file
    return urls.find(isGlbOrGltf) || urls[0];
};

// ─── Main Component ─────────────────────────────────────
const FD100ExpoSuiviPiecesPublic = () => {
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [lightboxUrl, setLightboxUrl] = useState(null);
    const [model3dModal, setModel3dModal] = useState(null);

    // Data
    const [allPartenaires, setAllPartenaires] = useState([]);
    const [pieces, setPieces] = useState([]);
    const [projects, setProjects] = useState([]);
    const [expoModeration, setExpoModeration] = useState({});
    const [moderationSelection, setModerationSelection] = useState({});
    const [moderationTypologie, setModerationTypologie] = useState({});
    const [moderationFabricant, setModerationFabricant] = useState({});
    const [dispoMap, setDispoMap] = useState({});

    // Filters & sort
    const [suiviSort, setSuiviSort] = useState(null);
    const [typologieView, setTypologieView] = useState(false);

    const [downloadingPieceId, setDownloadingPieceId] = useState(null);

    // Load model-viewer on mount
    useEffect(() => { loadModelViewer(); }, []);

    // ─── Fetch all data ─────────────────────────────────
    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const { data: allFabData } = await supabase
                .from('fd100_partenaires')
                .select('*')
                .eq('event_id', EVENT_ID)
                .in('type', ['fabricant', 'distributeur', 'editeur'])
                .order('name');
            setAllPartenaires(allFabData || []);

            const { data: piecesData } = await supabase
                .from('fd100_exposition_pieces')
                .select('*')
                .eq('event_id', EVENT_ID)
                .order('created_at', { ascending: false });
            setPieces(piecesData || []);

            const [response, { data: namesData }] = await Promise.all([
                api.getParticipatingUsersProjectData({ eventId: EVENT_ID, winnerProjectIds: WINNER_PROJECT_IDS, fullProjectData: true }),
                supabase.from('fd100_project_names').select('project_id, designer_definitive').eq('event_id', EVENT_ID)
            ]);
            const nameMap = {};
            (namesData || []).forEach(row => { if (row.designer_definitive) nameMap[row.project_id] = row.designer_definitive; });

            const winnerProjects = [];
            response.data.forEach(user => {
                if (user.participation?.data?.projets) {
                    user.participation.data.projets.forEach(projectId => {
                        const project = user.company?.projects?.find(p => p._id === projectId);
                        if (project && project.status === 'validé' && WINNER_PROJECT_IDS.includes(project._id)) {
                            winnerProjects.push({
                                ...project,
                                companyName: user.company?.name || '',
                                userName: nameMap[project._id] || '',
                                email: user.user?.email,
                            });
                        }
                    });
                }
            });
            setProjects(winnerProjects);

            const { data: dispoData } = await supabase
                .from('fd100_expo_disponibilite')
                .select('*')
                .eq('event_id', EVENT_ID);
            const dMap = {};
            (dispoData || []).forEach(row => { dMap[row.project_id] = row; });
            setDispoMap(dMap);

            const { data: modData } = await supabase
                .from('fd100_expo_moderation')
                .select('*')
                .eq('event_id', EVENT_ID);
            const modMap = {};
            const modSelMap = {};
            const modTypMap = {};
            const modFabMap = {};
            (modData || []).forEach(row => {
                modMap[row.project_id] = row.status;
                modSelMap[row.project_id] = row.selection_finale || 'pending';
                if (row.typologie) modTypMap[row.project_id] = row.typologie;
                if (row.fabricant) modFabMap[row.project_id] = row.fabricant;
            });
            setExpoModeration(modMap);
            setModerationSelection(modSelMap);
            setModerationTypologie(modTypMap);
            setModerationFabricant(modFabMap);
        } catch (err) {
            console.error('Error fetching expo data:', err);
            toast.error('Erreur lors du chargement');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchData(); }, [fetchData]);

    // ─── Maps ────────────────────────────────────────────
    const partenaireMap = useMemo(() => {
        const map = {};
        allPartenaires.forEach(p => { map[p.id] = p; });
        return map;
    }, [allPartenaires]);

    const projectMap = useMemo(() => {
        const map = {};
        projects.forEach(p => { map[p._id] = p; });
        return map;
    }, [projects]);

    const projectToPartenaire = useMemo(() => {
        const map = {};
        allPartenaires.forEach(p => {
            (p.linked_project_ids || []).forEach(pid => {
                if (!map[pid]) map[pid] = p;
            });
        });
        return map;
    }, [allPartenaires]);

    const getFabricant = useCallback((piece) => {
        if (piece.fabricant) return piece.fabricant;
        const projectName = (piece.project?.name_en || piece.project?.name || '').trim().toUpperCase();
        return projectName ? (BIBLE_FABRICANTS[projectName] || '') : '';
    }, []);

    const isAfMember = useCallback((partenaireName) => {
        if (!partenaireName) return false;
        return AF_MEMBER_NAMES.has(partenaireName.trim().toUpperCase());
    }, []);

    // Enriched pieces
    const enrichedPieces = useMemo(() => {
        return pieces.map(piece => {
            const partenaire = partenaireMap[piece.partenaire_id] || {};
            const project = projectMap[piece.project_id] || {};
            return { ...piece, partenaire, project };
        });
    }, [pieces, partenaireMap, projectMap]);

    // Pieces count per project (to detect multi-piece projects)
    const piecesCountByProject = useMemo(() => {
        const counts = {};
        pieces.forEach(p => {
            counts[p.project_id] = (counts[p.project_id] || 0) + 1;
        });
        return counts;
    }, [pieces]);

    const objetProjects = useMemo(() => projects.filter(p => p.type === 'objet'), [projects]);

    // Virtual pieces from approved objet moderation
    const approvedObjetPieces = useMemo(() => {
        const approved = objetProjects.filter(p => expoModeration[p._id] === 'oui');
        return approved.map(project => {
            const partenaire = projectToPartenaire[project._id] || {};
            const img = GetProjectMainImage(project);
            return {
                id: `mod-${project._id}`,
                _fromModeration: true,
                project_id: project._id,
                partenaire_id: partenaire.id || null,
                nom_piece: project.name_en || project.name || '',
                designer_names: DESIGNER_NAME_OVERRIDES[project._id] || project.userName || '',
                editeur: '',
                typologie: moderationTypologie[project._id] || project.category || project.type_objet || '',
                fabricant: moderationFabricant[project._id] || '',
                dimensions: '',
                materiaux: '',
                date_creation: '',
                photo_urls: img ? [img] : [],
                validation_finale: 'oui',
                selection_finale: moderationSelection[project._id] || 'pending',
                partenaire,
                project,
                created_at: null,
            };
        });
    }, [objetProjects, expoModeration, projectToPartenaire, moderationSelection, moderationTypologie, moderationFabricant]);

    // Combined pieces — confirmed + pending (exclude rejected 'non'), deduplicated
    const allPiecesForSuivi = useMemo(() => {
        // Deduplicate: if a project already has form-submitted pieces, skip its moderation virtual piece
        const projectIdsWithPieces = new Set(enrichedPieces.map(p => p.project_id));
        const uniqueApproved = approvedObjetPieces.filter(p => !projectIdsWithPieces.has(p.project_id));
        return [...enrichedPieces, ...uniqueApproved]
            .filter(p => p.selection_finale !== 'non')
            .filter(p => {
                // Confirmed pieces: apply availability filter
                if (p.selection_finale === 'oui') {
                    if (!p._fromModeration) return true;
                    return dispoMap[p.project_id]?.disponibilite === 'oui';
                }
                // Pending/à definir: always show
                return true;
            });
    }, [enrichedPieces, approvedObjetPieces, dispoMap]);

    // ─── Stats ───────────────────────────────────────────
    const partenaires = useMemo(() => allPartenaires.filter(p => p.pieces), [allPartenaires]);

    const stats = useMemo(() => {
        const confirmed = allPiecesForSuivi.filter(p => p.selection_finale === 'oui');
        const pending = allPiecesForSuivi.filter(p => p.selection_finale !== 'oui');
        const with3d = confirmed.filter(p => get3dFileForPiece(dispoMap[p.project_id])).length;
        return { totalPieces: confirmed.length, pendingCount: pending.length, with3d };
    }, [allPiecesForSuivi, dispoMap]);

    // ─── Search / Filter / Sort ─────────────────────────
    const filterBySearch = (items, fields) => {
        if (!searchTerm) return items;
        const s = searchTerm.toLowerCase();
        return items.filter(item => fields.some(fn => (fn(item) || '').toLowerCase().includes(s)));
    };

    const filteredPieces = useMemo(() => {
        let filtered = filterBySearch(allPiecesForSuivi, [
            p => p.nom_piece, p => p.partenaire?.name, p => p.designer_names,
            p => p.editeur, p => p.typologie, p => p.project?.name_en,
        ]);
        if (typologieView) {
            return [...filtered].sort((a, b) => {
                const aTyp = (a.typologie || '').toLowerCase();
                const bTyp = (b.typologie || '').toLowerCase();
                if (!aTyp && bTyp) return 1;
                if (aTyp && !bTyp) return -1;
                const typCmp = aTyp.localeCompare(bTyp, 'fr');
                if (typCmp !== 0) return typCmp;
                const aCod = a.partenaire?.codifab ? 0 : 1;
                const bCod = b.partenaire?.codifab ? 0 : 1;
                if (aCod !== bCod) return aCod - bCod;
                const aAf = isAfMember(a.partenaire?.name) ? 0 : 1;
                const bAf = isAfMember(b.partenaire?.name) ? 0 : 1;
                if (aAf !== bAf) return aAf - bAf;
                return 0;
            });
        }
        if (!suiviSort) return filtered;
        return [...filtered].sort((a, b) => {
            const aVal = (a.typologie || '').toLowerCase();
            const bVal = (b.typologie || '').toLowerCase();
            const cmp = aVal.localeCompare(bVal, 'fr');
            return suiviSort === 'asc' ? cmp : -cmp;
        });
    }, [allPiecesForSuivi, searchTerm, suiviSort, typologieView, isAfMember]);

    const confirmedFiltered = useMemo(() => filteredPieces.filter(p => p.selection_finale === 'oui'), [filteredPieces]);
    const pendingFiltered = useMemo(() => filteredPieces.filter(p => p.selection_finale !== 'oui'), [filteredPieces]);

    // ─── Download media for a single piece ─────────────
    const downloadPieceMedia = async (piece) => {
        const dispoRow = dispoMap[piece.project_id];
        const piecePhotos = piece.photo_urls || [];
        const dispoPhotos = dispoRow?.photo_urls || [];
        const file3dUrls = (dispoRow?.file_3d_urls || []).filter(u => u);
        const allUrls = [...new Set([...piecePhotos, ...dispoPhotos, ...file3dUrls])];

        if (allUrls.length === 0) {
            toast.error('Aucun fichier disponible');
            return;
        }

        // Single file → direct download
        if (allUrls.length === 1) {
            const link = document.createElement('a');
            link.href = allUrls[0];
            link.download = allUrls[0].split('/').pop().split('?')[0];
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return;
        }

        setDownloadingPieceId(piece.id);
        const toastId = toast.loading('Préparation du ZIP...');
        try {
            const zip = new JSZip();
            for (const url of allUrls) {
                try {
                    const resp = await fetch(url);
                    if (!resp.ok) continue;
                    const blob = await resp.blob();
                    const fileName = url.split('/').pop().split('?')[0] || `file_${Math.random().toString(36).slice(2)}`;
                    zip.file(fileName, blob);
                } catch { /* skip */ }
            }
            const content = await zip.generateAsync({ type: 'blob' });
            const url = URL.createObjectURL(content);
            const link = document.createElement('a');
            link.href = url;
            const pieceName = (dispoRow?.nom_piece || piece.nom_piece || 'piece').replace(/[/\\?%*:|"<>]/g, '_');
            link.download = `${pieceName}_medias.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            toast.success('Téléchargement terminé', { id: toastId });
        } catch (err) {
            console.error('Piece media download error:', err);
            toast.error('Erreur lors du téléchargement', { id: toastId });
        } finally {
            setDownloadingPieceId(null);
        }
    };

    // ─── Export Excel ───────────────────────────────────
    const exportExcel = async () => {
        const toastId = toast.loading('Export Excel en cours...');
        try {
            const workbook = new ExcelJS.Workbook();
            const ws = workbook.addWorksheet('Suivi Pieces');

            ws.columns = [
                { header: 'N°', key: 'num', width: 5 },
                { header: 'Photo', key: 'photo', width: 18 },
                { header: 'Nom de la pièce', key: 'nom_piece', width: 25 },
                { header: 'Projet FD100', key: 'projet', width: 25 },
                { header: 'Designer', key: 'designer', width: 20 },
                { header: 'Partenaire', key: 'partenaire', width: 20 },
                { header: 'Fabricant', key: 'fabricant', width: 20 },
                { header: 'Type', key: 'type', width: 12 },
                { header: 'Éditeur', key: 'editeur', width: 15 },
                { header: 'Typologie', key: 'typologie', width: 15 },
                { header: 'CODIFAB', key: 'codifab', width: 10 },
                { header: 'AF', key: 'af', width: 6 },
                { header: 'Dimensions', key: 'dimensions', width: 15 },
                { header: 'Matériaux', key: 'materiaux', width: 15 },
                { header: 'Poids', key: 'poids', width: 8 },
                { header: 'Val. assurance', key: 'valeur_assurance', width: 14 },
                { header: 'Année', key: 'annee', width: 8 },
                { header: 'Fichier 3D', key: 'file_3d', width: 10 },
                { header: 'Source', key: 'source', width: 15 },
            ];

            const headerRow = ws.getRow(1);
            headerRow.font = { bold: true };
            headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } };

            const photoCol = 2;

            const imagePromises = filteredPieces.map(async (p) => {
                const url = p.photo_urls?.[0];
                if (!url) return null;
                try {
                    const resp = await fetch(url);
                    if (!resp.ok) return null;
                    const buf = await resp.arrayBuffer();
                    const ext = url.match(/\.(png|gif|webp)(\?|$)/i) ? url.match(/\.(png|gif|webp)/i)[1].toLowerCase() : 'jpeg';
                    return { buffer: buf, extension: ext };
                } catch { return null; }
            });
            const images = await Promise.all(imagePromises);

            for (let i = 0; i < filteredPieces.length; i++) {
                const p = filteredPieces[i];
                const dispoRow = dispoMap[p.project_id];
                const isMulti = piecesCountByProject[p.project_id] > 1;

                const row = ws.addRow({
                    num: i + 1,
                    photo: '',
                    nom_piece: (!isMulti && dispoRow?.nom_piece) || p.nom_piece || '',
                    projet: p.project?.name_en || p.project?.name || '',
                    designer: dispoRow?.designer_names || p.designer_names || '',
                    partenaire: p.partenaire?.name || '',
                    fabricant: getFabricant(p),
                    type: (p._fromModeration || p.project?.type === 'objet') ? 'Créateur' : (p.partenaire?.type === 'fabricant' ? 'Fabricant' : p.partenaire?.type === 'editeur' ? 'Éditeur' : p.partenaire?.type === 'distributeur' ? 'Distributeur' : p.partenaire?.type || ''),
                    editeur: (!isMulti && dispoRow?.editeur) || p.editeur || '',
                    typologie: (!isMulti && dispoRow?.typologie) || p.typologie || '',
                    codifab: p.partenaire?.codifab || '',
                    af: isAfMember(p.partenaire?.name) ? 'Oui' : '',
                    dimensions: (!isMulti && dispoRow?.dimensions) || p.dimensions || '',
                    materiaux: (!isMulti && dispoRow?.materiaux) || p.materiaux || '',
                    poids: (!isMulti && dispoRow?.poids) || p.poids || '',
                    valeur_assurance: (!isMulti && dispoRow?.valeur_assurance) || p.valeur_assurance || '',
                    annee: (!isMulti && dispoRow?.date_creation) || p.date_creation || '',
                    file_3d: get3dFileForPiece(dispoRow) ? 'Oui' : '',
                    source: p._fromModeration ? 'Modération objet' : 'Formulaire',
                });

                const imgData = images[i];
                if (imgData) {
                    const imageId = workbook.addImage({ buffer: imgData.buffer, extension: imgData.extension });
                    const rowNum = row.number;
                    ws.addImage(imageId, {
                        tl: { col: photoCol - 1, row: rowNum - 1 },
                        ext: { width: 90, height: 65 },
                        editAs: 'oneCell',
                    });
                    row.height = 55;
                }
            }

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `FD100_Expo_Suivi_Pieces_${new Date().toISOString().slice(0, 10)}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            toast.success('Export terminé', { id: toastId });
        } catch (err) {
            console.error('Excel export error:', err);
            toast.error("Erreur lors de l'export", { id: toastId });
        }
    };

    // ─── Download all media as ZIP ──────────────────────
    const downloadMedia = async () => {
        const toastId = toast.loading('Préparation du téléchargement...');
        try {
            const zip = new JSZip();
            let count = 0;

            for (const piece of filteredPieces) {
                const urls = piece.photo_urls || [];
                const dispoRow = dispoMap[piece.project_id];
                const dispoPhotos = dispoRow?.photo_urls || [];
                const allUrls = [...new Set([...urls, ...dispoPhotos])];

                for (const url of allUrls) {
                    try {
                        const resp = await fetch(url);
                        if (!resp.ok) continue;
                        const blob = await resp.blob();
                        const fileName = url.split('/').pop().split('?')[0] || `photo_${count}.jpg`;
                        const folderName = (piece.nom_piece || piece.project?.name_en || `piece_${count}`).replace(/[/\\?%*:|"<>]/g, '_');
                        zip.file(`${folderName}/${fileName}`, blob);
                        count++;
                    } catch { /* skip */ }
                }

                // Include 3D files
                const file3dUrls = dispoRow?.file_3d_urls || [];
                for (const url of file3dUrls) {
                    try {
                        const resp = await fetch(url);
                        if (!resp.ok) continue;
                        const blob = await resp.blob();
                        const fileName = url.split('/').pop().split('?')[0] || `model_${count}.glb`;
                        const folderName = (piece.nom_piece || piece.project?.name_en || `piece_${count}`).replace(/[/\\?%*:|"<>]/g, '_');
                        zip.file(`${folderName}/${fileName}`, blob);
                        count++;
                    } catch { /* skip */ }
                }
            }

            if (count === 0) {
                toast.error('Aucun fichier à télécharger', { id: toastId });
                return;
            }

            const content = await zip.generateAsync({ type: 'blob' });
            const url = URL.createObjectURL(content);
            const link = document.createElement('a');
            link.href = url;
            link.download = `FD100_Expo_Media_${new Date().toISOString().slice(0, 10)}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            toast.success(`${count} fichiers téléchargés`, { id: toastId });
        } catch (err) {
            console.error('Media download error:', err);
            toast.error('Erreur lors du téléchargement', { id: toastId });
        }
    };

    // ─── Format helpers ─────────────────────────────────
    const fmtDate = (d) => {
        if (!d) return '—';
        return new Date(d).toLocaleDateString('fr-FR', {
            day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
        });
    };

    // ─── Piece row renderer ─────────────────────────────
    const renderPieceRow = (piece, idx, isPending) => {
        const hasCodifab = !!piece.partenaire?.codifab;
        const hasAf = isAfMember(piece.partenaire?.name);
        const dispoRow = dispoMap[piece.project_id];
        const isMulti = piecesCountByProject[piece.project_id] > 1;
        const file3d = get3dFileForPiece(dispoRow);
        const piecePhotos = piece.photo_urls || [];
        const dispoPhotos = dispoRow?.photo_urls || [];
        const allMediaUrls = [...new Set([...piecePhotos, ...dispoPhotos])];

        const tdTypologie = (
            <td key="typ">{(!isMulti && dispoRow?.typologie) || piece.typologie || '—'}</td>
        );
        const tdCodifab = (
            <td key="cod">
                {hasCodifab ? (
                    <Badge type="oui">{piece.partenaire.codifab}</Badge>
                ) : '—'}
            </td>
        );
        const tdAf = (
            <td key="af">
                {hasAf ? (
                    <Badge type="oui">AF</Badge>
                ) : '—'}
            </td>
        );

        return (
            <PieceRow key={piece.id} pending={isPending}>
                {typologieView && tdTypologie}
                {typologieView && tdCodifab}
                {typologieView && tdAf}
                <td>{idx + 1}</td>
                <td>
                    {piece.photo_urls?.length > 0 ? (
                        <PhotoThumb src={piece.photo_urls[0]} alt="" onClick={() => setLightboxUrl(piece.photo_urls[0])} />
                    ) : (
                        <NoPhoto>—</NoPhoto>
                    )}
                </td>
                <td>
                    <strong>{(!isMulti && dispoRow?.nom_piece) || piece.nom_piece || '—'}</strong>
                    {piece._fromModeration && <Badge type="objet" style={{ marginLeft: 8, fontSize: 11 }}>Modération</Badge>}
                </td>
                <td>{piece.project?.name_en || piece.project?.name || '—'}</td>
                <td>{dispoRow?.designer_names || piece.designer_names || '—'}</td>
                <td>{piece.partenaire?.name || '—'}</td>
                <td>
                    {(() => {
                        const fabValue = getFabricant(piece);
                        const isBibleFallback = !piece.fabricant && fabValue;
                        return (
                            <span style={{ color: fabValue ? (isBibleFallback ? '#999' : '#333') : '#ccc', fontStyle: isBibleFallback ? 'italic' : 'normal' }}
                                  title={isBibleFallback ? 'Source: Bible catalogue' : ''}>
                                {fabValue || '—'}
                            </span>
                        );
                    })()}
                </td>
                <td>
                    {(piece._fromModeration || piece.project?.type === 'objet') ? (
                        <Badge type="contact">Créateur</Badge>
                    ) : (
                        <Badge type={piece.partenaire?.type === 'fabricant' ? 'objet' : 'espace'}>
                            {piece.partenaire?.type === 'fabricant' ? 'Fabricant'
                                : piece.partenaire?.type === 'editeur' ? 'Éditeur'
                                : piece.partenaire?.type === 'distributeur' ? 'Distributeur'
                                : piece.partenaire?.type || '—'}
                        </Badge>
                    )}
                </td>
                <td>{(!isMulti && dispoRow?.editeur) || piece.editeur || '—'}</td>
                {!typologieView && tdTypologie}
                {!typologieView && tdCodifab}
                {!typologieView && tdAf}
                <td>{(!isMulti && dispoRow?.dimensions) || piece.dimensions || '—'}</td>
                <td>{(!isMulti && dispoRow?.materiaux) || piece.materiaux || '—'}</td>
                <td>{(!isMulti && dispoRow?.poids) || piece.poids || '—'}</td>
                <td>{(!isMulti && dispoRow?.valeur_assurance) || piece.valeur_assurance || '—'}</td>
                <td>{(!isMulti && dispoRow?.date_creation) || piece.date_creation || '—'}</td>
                <td>
                    {allMediaUrls.length > 0 ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                            {allMediaUrls.slice(0, 3).map((url, i) => (
                                <img
                                    key={i} src={url} alt=""
                                    style={{ width: 36, height: 36, objectFit: 'cover', borderRadius: 4, cursor: 'pointer', border: '1px solid #e0e0e0' }}
                                    onClick={() => setLightboxUrl(url)}
                                />
                            ))}
                            {allMediaUrls.length > 3 && (
                                <span style={{ fontSize: 11, color: '#888', fontWeight: 600 }}>+{allMediaUrls.length - 3}</span>
                            )}
                            <span
                                style={{ cursor: downloadingPieceId === piece.id ? 'wait' : 'pointer', fontSize: 16, opacity: downloadingPieceId === piece.id ? 0.4 : 0.7, marginLeft: 2 }}
                                onClick={() => downloadingPieceId !== piece.id && downloadPieceMedia(piece)}
                                title="Télécharger les médias"
                            >
                                ⬇
                            </span>
                        </div>
                    ) : (
                        <span style={{ color: '#ccc' }}>—</span>
                    )}
                </td>
                <td>
                    {file3d ? (
                        isGlbOrGltf(file3d) ? (
                            <ModelViewerWrapper onClick={() => setModel3dModal({ url: file3d, name: dispoRow?.nom_piece || piece.nom_piece, isGlb: true })}>
                                <model-viewer
                                    src={file3d}
                                    alt="3D"
                                    auto-rotate
                                    interaction-prompt="none"
                                    style={{ width: '100%', height: '100%', pointerEvents: 'none' }}
                                />
                            </ModelViewerWrapper>
                        ) : (
                            <ModelViewerWrapper onClick={() => setModel3dModal({ url: file3d, name: dispoRow?.nom_piece || piece.nom_piece, isGlb: false })}>
                                <ThreeModelViewer url={file3d} width={60} height={60} />
                            </ModelViewerWrapper>
                        )
                    ) : (
                        <No3D>—</No3D>
                    )}
                </td>
            </PieceRow>
        );
    };

    // ─── Render ─────────────────────────────────────────
    if (loading) {
        return (
            <PageWrapper>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <Spinner />
                </div>
            </PageWrapper>
        );
    }

    return (
        <PageWrapper>
            <Toaster position="top-right" />

            {/* Lightbox */}
            {lightboxUrl && (
                <LightboxOverlay onClick={() => setLightboxUrl(null)}>
                    <img src={lightboxUrl} alt="" />
                </LightboxOverlay>
            )}

            {/* 3D Model Modal */}
            {model3dModal && (
                <ModalOverlay onClick={() => setModel3dModal(null)}>
                    <ModalContent onClick={e => e.stopPropagation()} style={{ width: 900 }}>
                        <h2>{model3dModal.name || 'Modèle 3D'}</h2>
                        <ModelViewerLargeWrapper>
                            {model3dModal.isGlb ? (
                                <model-viewer
                                    src={model3dModal.url}
                                    alt={model3dModal.name || '3D model'}
                                    auto-rotate
                                    camera-controls
                                    shadow-intensity="1"
                                    environment-image="neutral"
                                    style={{ width: '100%', height: '100%' }}
                                />
                            ) : (
                                <ThreeModelViewer
                                    url={model3dModal.url}
                                    width={860}
                                    height={500}
                                    interactive
                                />
                            )}
                        </ModelViewerLargeWrapper>
                        <div style={{ marginTop: 16, display: 'flex', gap: 12, justifyContent: 'space-between', alignItems: 'center' }}>
                            <a href={model3dModal.url} download style={{ color: '#e67e22', fontWeight: 600, fontSize: 14, textDecoration: 'none' }}>
                                Telecharger le fichier 3D
                            </a>
                            <ActionButton onClick={() => setModel3dModal(null)}>Fermer</ActionButton>
                        </div>
                    </ModalContent>
                </ModalOverlay>
            )}

            {/* Top bar */}
            <TopBar>
                <LogoArea>
                    <div>
                        <h1>Le FD100 — Suivi des pièces exposition</h1>
                        <div className="subtitle">4ème édition — Données en temps réel</div>
                    </div>
                </LogoArea>
                <HeaderActions>
                    <ActionButton onClick={fetchData}>Actualiser</ActionButton>
                    <ActionButton variant="primary" onClick={exportExcel}>Exporter Excel</ActionButton>
                    <ActionButton variant="success" onClick={downloadMedia}>Télécharger médias</ActionButton>
                </HeaderActions>
            </TopBar>

            <Container>
                {/* Stats */}
                <StatsSection>
                    <StatCard color="#f5eef8" textColor="#8e44ad">
                        <div className="value">{stats.totalPieces}</div>
                        <div className="label">Pièces confirmées</div>
                    </StatCard>
                    <StatCard color="#fff8e1" textColor="#f57f17">
                        <div className="value">{stats.pendingCount}</div>
                        <div className="label">Pièces à définir</div>
                    </StatCard>
                    <StatCard color="#eaf2f8" textColor="#2980b9">
                        <div className="value">{stats.with3d}</div>
                        <div className="label">Modèles 3D</div>
                    </StatCard>
                </StatsSection>

                {/* Table */}
                <TableSection>
                    <TableHeader>
                        <h2>Suivi général des pièces ({confirmedFiltered.length}{pendingFiltered.length > 0 ? ` + ${pendingFiltered.length} à définir` : ''})</h2>
                        <HeaderActions>
                            <SearchInput placeholder="Rechercher..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                            <ToggleButton
                                active={typologieView}
                                onClick={() => { setTypologieView(prev => !prev); if (!typologieView) setSuiviSort(null); }}
                            >
                                {typologieView ? 'Vue Typologie ✓' : 'Vue Typologie'}
                            </ToggleButton>
                        </HeaderActions>
                    </TableHeader>

                    {filteredPieces.length === 0 ? (
                        <EmptyState>Aucune pièce soumise pour le moment</EmptyState>
                    ) : (
                        <Table>
                            <thead>
                                <tr>
                                    {typologieView && <th style={{ background: '#fff3e0' }}>Typologie</th>}
                                    {typologieView && <th style={{ background: '#fff3e0' }}>CODIFAB</th>}
                                    {typologieView && <th style={{ background: '#fff3e0' }}>AF</th>}
                                    <th>N°</th>
                                    <th>Photo</th>
                                    <th>Nom de la pièce</th>
                                    <th>Projet FD100</th>
                                    <th>Designer</th>
                                    <th>Partenaire</th>
                                    <th>Fabricant</th>
                                    <th>Type</th>
                                    <th>Éditeur</th>
                                    {!typologieView && (
                                        <th
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                            onClick={() => setSuiviSort(prev => prev === 'asc' ? 'desc' : prev === 'desc' ? null : 'asc')}
                                        >
                                            Typologie {suiviSort === 'asc' ? '▲' : suiviSort === 'desc' ? '▼' : ''}
                                        </th>
                                    )}
                                    {!typologieView && <th>CODIFAB</th>}
                                    {!typologieView && <th>AF</th>}
                                    <th>Dimensions</th>
                                    <th>Matériaux</th>
                                    <th>Poids</th>
                                    <th>Val. assurance</th>
                                    <th>Année</th>
                                    <th>Médias</th>
                                    <th>3D</th>
                                </tr>
                            </thead>
                            <tbody>
                                {confirmedFiltered.map((piece, idx) => renderPieceRow(piece, idx, false))}
                                {pendingFiltered.length > 0 && (
                                    <tr>
                                        <td colSpan={99} style={{
                                            background: '#fff8e1',
                                            padding: '14px 16px',
                                            fontWeight: 700,
                                            color: '#f57f17',
                                            borderTop: '3px solid #ffe082',
                                            borderBottom: '2px solid #ffe082',
                                            textAlign: 'center',
                                            fontSize: 14,
                                        }}>
                                            Pièces à définir ({pendingFiltered.length})
                                        </td>
                                    </tr>
                                )}
                                {pendingFiltered.map((piece, idx) => renderPieceRow(piece, idx, true))}
                            </tbody>
                        </Table>
                    )}
                </TableSection>
            </Container>
        </PageWrapper>
    );
};

export default FD100ExpoSuiviPiecesPublic;
